/**
 * Routes that must emit noindex even when the page itself has no PageHelmet.
 * Account and flight booking confirmation already set noIndex on their own helmet.
 */

export const ADMIN_PATH_PREFIX = '/admin';
export const HOTEL_BOOKING_CONFIRMATION_PATH = '/hotel-booking-confirmation';

/**
 * @param {string | undefined | null} pathname
 * @returns {string}
 */
export function normalizeRobotsPath(pathname) {
  return (pathname || '/').replace(/\/+$/, '') || '/';
}

/**
 * @param {string | undefined | null} pathname
 * @returns {boolean}
 */
export function isAdminPath(pathname) {
  const path = normalizeRobotsPath(pathname);
  return path === ADMIN_PATH_PREFIX || path.startsWith(`${ADMIN_PATH_PREFIX}/`);
}

/**
 * Pages with no helmet of their own. A second helmet on pages that already
 * set robots would publish two robots tags.
 *
 * @param {string | undefined | null} pathname
 * @returns {boolean}
 */
export function needsStandaloneNoIndex(pathname) {
  const path = normalizeRobotsPath(pathname);
  if (isAdminPath(path)) return true;
  return (
    path === HOTEL_BOOKING_CONFIRMATION_PATH
    || path.startsWith(`${HOTEL_BOOKING_CONFIRMATION_PATH}/`)
  );
}
